import PropTypes from "prop-types";
import "./InventarioSidebarSkeleton.css";
import { TAB_NAMES } from "../../const/inventario";

/**
 * Skeleton para el sidebar de almacenes o categorías.
 * Se muestra durante la carga de datos (estado "loading").
 */
export const InventarioSidebarSkeleton = ({ count, activeTab }) => {
  return (
    <aside className="inv-sidebar">
      {activeTab === TAB_NAMES.stores && (
        <div className="inv-sec-header">
          <span className="inv-sec-title skeleton-header"></span>
          <div className="skeleton-button"></div>
        </div>
      )}

      <ul className="skeleton-list">
        {Array.from({ length: count }).map((_, i) => (
          <li key={`item-${i}`} className="skeleton-item">
            {activeTab === TAB_NAMES.stores ? (
              <>
                <div className="skeleton-store-line">
                  <div className="skeleton-store-name"></div>
                  <div className="skeleton-toggle"></div>
                </div>
                <div className="skeleton-store-meta"></div>
              </>
            ) : (
              <div className="skeleton-item-simple">
                <div className="skeleton-simple-line">
                  <div className="skeleton-simple-name"></div>
                </div>
              </div>
            )}
          </li>
        ))}
      </ul>
    </aside>
  );
};

InventarioSidebarSkeleton.propTypes = {
  count: PropTypes.number,
  activeTab: PropTypes.string,
};
